









































import { Component, Vue } from 'vue-property-decorator';
import {store} from '../_store';
import {ACCOUNT_ACTION} from "@/_store/account";

@Component
export default class Forgot extends Vue {
    private sending: boolean = false;
    private email: string = '';
    private emailRules = [
        (v: string) => !!v || 'E-mail is required',
        (v: string) => /.+@.+/.test(v) || 'E-mail must be valid',
    ];

    private async submit() {
        if ((this.$refs.form as any).validate() ) {
            this.sending = await store.dispatch(ACCOUNT_ACTION.FORGOT, {email: this.email});
        }
    }

  get env() {
    return this.$store.getters["api/env"];
  }
}
